export const homeAni = {
  initial: {
    y: 100,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
  },
};

export const designAni = {
  initial: {
    y: 100,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 1,
      ease: "easeOut",
      delayChildren: 0.2,
    },
  },
};
export const designAni2 = {
  initial: {
    y: 100,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
    
  },
};
export const container = {
  initial: { opacity: 0, transition: { when: "afterChildren" } },
  animate: {
    opacity: 1,
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.2,
      duration: 0.6,
      when: "beforeChildren",
    },
  },
};

export const item = {
  initial: { y: 100, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
    },
  },
};

export const title = {
  initial: { opacity: 1 },
  animate: { opacity: 0 },
};
export const title2 = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { delay: 0.4 } },
};

export const IconAni = {
  initial: {
    rotate: 0,
  },
  animate: {
    rotate: [0, 360],
  },
};
export const container2 = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,

    transition: {
      delayChildren: 0.7,
      staggerChildren: 0.2,
      duration: 0.7,
     
    },
  },
  
};

export const item2 = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
  },
};
